// extracted by mini-css-extract-plugin
export default {"ui":"style_ui__QwVP3","nftbutton":"style_nftbutton__DDDM6","nbw":"style_nbw__JDW4A","nbb":"style_nbb__OMwRs"};